import api from "../apis/FitnessApi";

const getErrorMessage = (err, fallback) =>
  err?.response?.data?.message ||
  err?.response?.data?.error ||
  err?.message ||
  fallback;

export const ListFitnessTrainers =
  (params, onSuccess, onError) => () => {
    api
      .FitnessApi()
      .listTrainers(params)
      .then((res) => {
        const data = res?.data?.data;
        const trainers = data?.trainers ?? data ?? [];
        onSuccess?.(Array.isArray(trainers) ? trainers : []);
      })
      .catch((err) => {
        onError?.(getErrorMessage(err, "Failed to fetch trainers"));
      });
  };

export const CreateFitnessTrainer =
  (data, onSuccess, onError) => () => {
    api
      .FitnessApi()
      .createTrainer(data)
      .then((res) => {
        onSuccess?.(res?.data);
      })
      .catch((err) => {
        onError?.(getErrorMessage(err, "Failed to create trainer"));
      });
  };

export const UpdateFitnessTrainer =
  (trainerId, data, onSuccess, onError) => () => {
    api
      .FitnessApi()
      .updateTrainer(trainerId, data)
      .then((res) => {
        onSuccess?.(res?.data);
      })
      .catch((err) => {
        onError?.(getErrorMessage(err, "Failed to update trainer"));
      });
  };

export const GetFitnessWorkingHours =
  (params, onSuccess, onError) => () => {
    api
      .FitnessApi()
      .getWorkingHours(params)
      .then((res) => {
        const data = res?.data?.data ?? res?.data;
        onSuccess?.(data?.workingHours ?? null);
      })
      .catch((err) => {
        onError?.(getErrorMessage(err, "Failed to fetch working hours"));
      });
  };

export const SetFitnessWorkingHours =
  (data, onSuccess, onError) => () => {
    api
      .FitnessApi()
      .setWorkingHours(data)
      .then((res) => {
        onSuccess?.(res?.data);
      })
      .catch((err) => {
        onError?.(getErrorMessage(err, "Failed to set working hours"));
      });
  };

export const AddFitnessCustomSlots =
  (data, onSuccess, onError) => () => {
    api
      .FitnessApi()
      .addCustomSlots(data)
      .then((res) => {
        onSuccess?.(res?.data);
      })
      .catch((err) => {
        onError?.(getErrorMessage(err, "Failed to add custom slots"));
      });
  };

export const BlockFitnessSlots =
  (data, onSuccess, onError) => () => {
    api
      .FitnessApi()
      .blockSlots(data)
      .then((res) => {
        onSuccess?.(res?.data);
      })
      .catch((err) => {
        onError?.(getErrorMessage(err, "Failed to block slots"));
      });
  };

export const AdminBookFitnessSession =
  (data, onSuccess, onError) => () => {
    api
      .FitnessApi()
      .adminBookSession(data)
      .then((res) => {
        onSuccess?.(res?.data);
      })
      .catch((err) => {
        onError?.(getErrorMessage(err, "Failed to book session"));
      });
  };

export const ListFitnessSessions =
  (params, onSuccess, onError) => () => {
    api
      .FitnessApi()
      .listSessions(params)
      .then((res) => {
        const body = res?.data;
        const nested = body?.data;

        // Supports:
        // 1) { data: [...], total, page, limit, totalPages }
        // 2) { data: { sessions: [...], pagination: {...} } }
        const sessions = Array.isArray(nested)
          ? nested
          : nested?.sessions ?? body?.sessions ?? [];

        const pagination = nested?.pagination ??
          (typeof body?.total === "number" || typeof body?.totalPages === "number"
            ? {
                currentPage: body?.page ?? 1,
                totalPages: body?.totalPages,
                totalRecords: body?.total ?? sessions.length,
                limit: body?.limit ?? 20,
              }
            : null);

        onSuccess?.({ sessions, pagination });
      })
      .catch((err) => {
        onError?.(getErrorMessage(err, "Failed to fetch sessions"));
      });
  };

export const CheckFitnessLearnerStatus =
  (data, onSuccess, onError) => () => {
    api
      .FitnessApi()
      .checkLearnerStatus(data)
      .then((res) => {
        onSuccess?.(res?.data?.data ?? res?.data);
      })
      .catch((err) => {
        onError?.(getErrorMessage(err, "Failed to check learner status"));
      });
  };

export const GetFitnessAvailableSlots =
  (data, onSuccess, onError) => () => {
    api
      .FitnessApi()
      .availableSlots(data)
      .then((res) => {
        onSuccess?.(res?.data?.data ?? res?.data);
      })
      .catch((err) => {
        onError?.(getErrorMessage(err, "Failed to fetch available slots"));
      });
  };

export const CancelFitnessSession =
  (data, onSuccess, onError) => () => {
    api
      .FitnessApi()
      .cancelSession(data)
      .then((res) => {
        onSuccess?.(res?.data);
      })
      .catch((err) => {
        onError?.(getErrorMessage(err, "Failed to cancel session"));
      });
  };

export const RescheduleFitnessSession =
  (data, onSuccess, onError) => () => {
    api
      .FitnessApi()
      .rescheduleSession(data)
      .then((res) => {
        onSuccess?.(res?.data);
      })
      .catch((err) => {
        onError?.(getErrorMessage(err, "Failed to reschedule session"));
      });
  };
